import { useEffect, useRef, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { AuthShell } from '@/components/AuthShell';
import { useActiveOrg } from '@/components/OrgPicker';
import { Spinner } from '@/components/ui';
import { useAuth } from '@/context/AuthContext';
import { safeReturn } from '@/lib/signIn';

// SSOCompletePage - where the orchestrator sends the browser once an identity
// provider signed the person in, /sso/complete?org=&return=. The session
// cookie is already set: the org they signed in through becomes the active
// one, the session is read, and they go where they were headed.
export default function SSOCompletePage() {
  const { user, refresh } = useAuth();
  const { pick } = useActiveOrg();
  const [params] = useSearchParams();
  const [read, setRead] = useState(false);
  const started = useRef(false);

  const org = params.get('org');
  useEffect(() => {
    // Once: a re-render while refresh is in flight must not start another.
    if (started.current) return;
    started.current = true;
    if (org?.startsWith('org-')) pick(org);
    void refresh().finally(() => setRead(true));
  }, [org, pick, refresh]);

  if (read) {
    return <Navigate to={user ? safeReturn(params.get('return')) : '/login?error=sso_failed'} replace />;
  }
  return (
    <AuthShell subtitle="Precision malware analysis">
      <div className="card p-8 flex items-center justify-center gap-3 text-sm text-ink-300">
        <Spinner size={16} />
        Signing you in
      </div>
    </AuthShell>
  );
}
